import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-bootstrap'

import FixturesItems from '@shared/components/series/fixturesItems'
import NoData from '@shared/components/noData'

const TeamMatch = ({ teamMatch }) => {
  return (
    <Row>
      {
        teamMatch.length > 0 ? (
          <>
            {
              teamMatch?.map((match) => {
                return <Col xl={6} key={match._id} className='mb-4'>
                  <FixturesItems fixture={match} />
                </Col>
              })
            }
          </>
        ) : <NoData />
      }
    </Row>
  )
}

TeamMatch.propTypes = {
  teamMatch: PropTypes.arrayOf(PropTypes.object)
}

export default TeamMatch
